import { render } from "./DeviatingAddressForm.vue?vue&type=template&id=949f32e8&ts=true"
import script from "./DeviatingAddressForm.vue?vue&type=script&lang=ts"
export * from "./DeviatingAddressForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__